import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import { injectIntl, useIntl } from 'react-intl';

import { userHasCap } from '../../helpers/Auth';
import { runAction } from '../../helpers/Integrations';

const FileActionsIntegrations = ({
  integrations,
  component,
  files,
}) => {
  const intl = useIntl();

  const [isOpen, setIsOpen] = useState(false);

  if (!userHasCap('integrations')) {
    return null;
  }

  let actions = [];
  integrations.forEach((integration) => {
    actions = actions.concat(integration.actions.map(i => ({ serviceId: integration.id, ...i })));
  });

  if (actions.length === 0) {
    return null;
  }

  return (
    <>
      {component === 'dropdown' && (
        <>
          <DropdownItem divider />
          <DropdownItem
            className="dropdown-submenu"
            tag="a"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            <Dropdown
              className="integrations-actions-dropdown"
              direction="right"
              isOpen={isOpen}
              onMouseOver={() => setIsOpen(true)}
              onFocus={() => setIsOpen(true)}
              onMouseLeave={() => setIsOpen(false)}
              onBlur={() => setIsOpen(false)}
              toggle={() => setIsOpen(!isOpen)}
            >
              <DropdownToggle tag="span" caret>
                <i className="fas fa-circle-nodes" />
                {intl.formatMessage({ defaultMessage: 'Integrations' })}
              </DropdownToggle>
              <DropdownMenu>
                {actions.map(action => (
                  <DropdownItem
                    key={`${action.serviceId}.${action.id}`}
                    onClick={() => {
                      runAction(action, files);
                    }}
                  >
                    {action.icon && (
                      <i className={action.icon} />
                    )}
                    {action.image && (
                      <img src={action.image} alt="" />
                    )}
                    {action.title}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </DropdownItem>
        </>
      )}
    </>
  );
};

const mapStateToProps = state => ({
  integrations: state.Auth.profile.integrations,
});

FileActionsIntegrations.propTypes = {
  integrations: PropTypes.array.isRequired,
  component: PropTypes.string,
  files: PropTypes.array.isRequired,
};

FileActionsIntegrations.defaultProps = {
  component: 'dropdown',
};

export default injectIntl(connect(mapStateToProps)(FileActionsIntegrations));
